import React from 'react';
import { Button } from '@mui/material';

export const Columns = (deleteAreaItem) => [
  {
    id: 'code',
    numeric: false,
    disablePadding: false,
    label: 'Mã',
    width: 10,
    sort: true,
    align: 'center',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Tên khu vực',
    align: 'center',
  },
  {
    id: 'nameEN',
    numeric: true,
    disablePadding: false,
    label: 'Khu vực (tiếng Anh)',
    align: 'center',
  },
  {
    id: 'nameCN',
    numeric: true,
    disablePadding: false,
    label: 'Khu vực (tiếng Hoa)',
    align: 'center',
  },
  {
    id: 'nameJP',
    numeric: true,
    disablePadding: false,
    label: 'Khu vực (tiếng Nhật)',
    align: 'center',
  },
  {
    id: 'note',
    numeric: true,
    disablePadding: false,
    label: 'Ghi Chú',
    align: 'center',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Thao tác',
    width: '10px',
    fixed: 'right',
    align: 'center',
    render: (row) => (
      <Button
        variant="contained"
        size="small"
        color="error"
        sx={{ borderRadius: '15px', textTransform: 'none' }}
        onClick={() => window.showConfirm(() => deleteAreaItem(row))}
      >
        Xoá
      </Button>
    ),
  },
];
